import { cloneElement, createContext, useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { HiXMark } from "react-icons/hi2";
import { useOutsideClick } from "../hooks/useOutsideClick";

const ModalContext = createContext();

function Modal({ children }) {
  const [openName, setOpenName] = useState("");

  const close = () => setOpenName("");
  const open = setOpenName;

  return (
    <ModalContext.Provider value={{ openName, close, open }}>
      {children}
    </ModalContext.Provider>
  );
}

function Open({ children, opens: opensWindowName }) {
  const { open } = useContext(ModalContext);

  return cloneElement(children, { onClick: () => open(opensWindowName) });
}

function Window({ children, name }) {
  const { openName, close } = useContext(ModalContext);
  const ref = useOutsideClick(close);

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === "Escape") {
        close();
      }
    }

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [close]);

  if (name !== openName) return null;

  return createPortal(
    <div className="fixed inset-0 z-[1000] h-screen w-full bg-black/30 backdrop-blur-[5px] transition-all duration-500 [transition-timing-function:ease]">
      <button
        className="absolute right-8 top-4 translate-x-[0.8rem] cursor-pointer border-none bg-transparent p-[0.4rem] transition-all duration-200 [transition-timing-function:ease] [&_svg]:h-[2.4rem] [&_svg]:w-[2.4rem] [&_svg]:fill-portfolio-title"
        onClick={close}
      >
        <HiXMark />
      </button>
      <div
        className="fixed left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 justify-center transition-all duration-500 [transition-timing-function:ease] max-[1024px]:w-full max-[1024px]:p-2"
        ref={ref}
      >
        {children && cloneElement(children)}
      </div>
    </div>,
    document.body
  );
}

Modal.Open = Open;
Modal.Window = Window;

export default Modal;
